import { Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';

import { RouterModule } from '@angular/router';
import { Web3Service } from '../../services/web3.service';


@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [RouterModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.css'
})
export class NavbarComponent {
  web3Service = inject(Web3Service);

}
